package presentation.screens.business.business_list

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.core.screen.uniqueScreenKey
import cafe.adriel.voyager.navigator.LocalNavigator
import component.empty.EmptyData
import component.loader.AppLoader
import component.navigation.TopNavBar
import feature.business.viewModel.BusinessViewModel
import presentation.screens.business.business_list.component.BusinessCard
import presentation.screens.business.onboard.select_business_type.SelectBusinessTypeScreen
import theme.ThemeColor

class BusinessListScreen : Screen {

    override val key = uniqueScreenKey

    @Composable
    override fun Content() {
        val viewModel = BusinessViewModel()
        val navigator = LocalNavigator.current
        val allBusiness = viewModel.allBusiness.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.loadBusiness()
        }

        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar(title = "Business List", onBackPress = {
                navigator?.pop()
            }, onClickAdd = {
                navigator?.push(SelectBusinessTypeScreen())
            })
            AppLoader(viewModel)
            if (allBusiness.value.isNotEmpty()) {
                LazyColumn {
                    items(allBusiness.value.count()) { index ->
                        BusinessCard(allBusiness.value[index]) {
                            viewModel.setSelectedBusiness(it)
                            navigator?.pop()
                        }
                    }
                }
            } else {
                EmptyData(viewModel = viewModel) {
                    viewModel.loadBusiness()
                }
            }
        }
    }
}
